<template>


    <!--Veracity help modal -->
    <div class="modal fade" id="rumourVeracityHelpModal" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Rumour Veracity Classification</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>
                        Rumours on this service is automatically classified between three categories
                        True,
                        False and Undecided as shown on the slider below:
                    </p>


                    <veracity-slider></veracity-slider>

                    <p>
                        The closer the slider handle is to the category, the more confidence there is
                        for
                        that category.
                    </p>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    import VeracitySlider from "./VeracitySlider";
    export default {
        name: "TweetVeracityHelpModal",
        components: {VeracitySlider}
    }
</script>

<style scoped>

</style>
